import { VIcon } from 'vuetify/lib/components/VIcon';

var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('base-grey-toggle-button',{attrs:{"value":_vm.value,"options":_vm.toggleOptions,"data-test":"view-mode-toggle"},on:{"input":function($event){return _vm.$emit('input', $event)}},scopedSlots:_vm._u([{key:"option",fn:function({ option }){return [_c(VIcon,{attrs:{"size":"18"}},[_vm._v(_vm._s(option.icon))])]}}])})
}
var staticRenderFns = []

export { render, staticRenderFns }